import { useSelector } from "react-redux";
import { BASENAME } from "../../../../utils/basename";

const PaypalReminder = () => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  return (
    <div className="w-full relative flex items-center bg-ribola-paypal-light text-white text-sm font-opensanssemibold mt-0 py-2 pl-4 sm:pl-16 pr-3">
      <img
        src={BASENAME + "/images/paypal_logo.svg"}
        width="39"
        height="39"
        className="flex-start self-start sm:absolute left-3 mr-3 sm:mr-0"
        alt="Paypal Logo"
      />
      <span
        dangerouslySetInnerHTML={{
          __html: genericheTranslation.paypalreminder.itemName,
        }}
      ></span>
    </div>
  );
};

export default PaypalReminder;
